import { configureStore } from '@reduxjs/toolkit';
import { bindReduxStore } from './reduxStoreBridge';
import { rootReducer } from './reducers/index';

const store = configureStore({
  reducer: rootReducer,
});

bindReduxStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
